import { Message, MessageGeneration, MessageRole } from '../types/chat';
import { useTheme } from '../../../components/core/theme-provider';
import { formatDate } from '../../../utils/custom-date';

interface ReplyBubbleProps {
    message: Message;
    generation: MessageGeneration;
}

function ReplyBubble({ message, generation }: ReplyBubbleProps) {
    const { theme } = useTheme();

    if (!generation?.parentMessage) {
        return null;
    }

    const bubbleBackground = theme === 'dark' ? 'bg-primary-600' : 'bg-primary-50';
    const primaryText = 'text-foreground';

    return (
        <div
            className={`flex justify-end ${message.role === MessageRole.USER_CHAT ? 'min-w-full' : 'w-full flex flex-col'
                }`}
        >
            <div className={`z-10 py-[14px] px-[13px] rounded-[8px] ${bubbleBackground} flex flex-col`}>
                <p
                    className={`text-sm font-normal leading-relaxed ${primaryText} line-clamp-2 ${message.role === MessageRole.USER_CHAT ? 'text-end' : ' text-start'} `}
                >
                    {generation.parentMessage.content}
                </p>


                <div className="flex items-center gap-2 mt-2 justify-end">
                    <span className={`text-xs font-semibold ${theme === 'dark' ? 'text-[#27272C]' : 'text-[#27272C]'}`}>
                        {generation.parentMessage.senderName}
                    </span>
                    <span className={`text-xs font-semibold ${theme === 'dark' ? 'text-[#BCBCBE]' : 'text-[#9C9C9E]'}`}>
                        {formatDate(new Date(generation.parentMessage.time))}
                    </span>
                </div>
            </div>
        </div >
    );
}

export default ReplyBubble;